import React from "react";
import "./Wecanhelp.css";
export default function BuildYourTrip() {

  let StartPlanning = (e) => {
      const url = "/makebuildtrip";
      window.location.replace(url);
  };
  return (
    <div
      className="appendBottom20 EventSection sticky-scroll"
      id="Offers_Listing"
    >
      <div className="container">
        <div className="EventlandingCard ">
          <div
            className="EventlandingCardSlider superOffers"
            style={{ direction: "ltr" }}
          >
            <div className="homepage-content">
						<h2 className="how-its-work">
							<span>Build your own Trip</span>
						</h2>	
              {/* <p>
                Find and create fully customized day by day itinerary of
                Places to Stay and Things to Do during your Seychelles
                Travels. You can add your interest by choosing from our
                defined itinerary or create your own.
              </p>				 */}
						<div className="row">
							<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
								<div className="thumb-1-wrap align-c">
									<span className="bbs">
                  <img src="images/tripplan/location1.png" alt="" style={{width:'174px'}}/>
									</span>
									<p>
										<b className="h-label">1. Select Your Destination</b>
										from 1M+ New &amp; popular Tourist Attractions
									</p>
								</div>
							</div>
							<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
								<div className="thumb-2-wrap align-c">
									<span className="bbs">
									
                  <img src="images/tripplan/accomodation1.png" alt="" style={{width:'170px'}}/>
									</span>
									<p>
										<b className="h-label">2. Select Your Accommodation</b>
										from 1M+ Accommodations around the Globe
									</p>
								</div>
							</div>
							<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
								<div className="thumb-3-wrap align-c">
									<span className="bbs">
                  <img src="images/tripplan/currency1.png" alt="" style={{width:'174px'}}/>
										
									</span>
									<p>
										<b className="h-label">3. Check Your Budget</b>
										with In-Built Trip Budget Calculator in Multiple Currencies
									</p>
								</div>
							</div>
							<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
								<div className="thumb-4-wrap align-c">
									<span className="bbs">																	
                  <img src="images/tripplan/setting1.png" alt="" style={{width:'168px'}}/>
									</span>
									<p>
										<b className="h-label">4. Finish Your Itinerary</b>
										with our Free online Vacation Planner in few minutes
									</p>
								</div>
							</div>
						</div>
						<div className="row align-c">
							<div className="col-lg-12">
              <button className="payLaterConfirmBooking primaryBtn"  onClick={StartPlanning}>
                            Start Planning
                          </button>
							</div></div>
					</div>
            {/* <section className="top-destinations">
              <div className="container">
                <div className="section-title text-center">
                  <h2>Build your own Trip </h2>
                </div>
                <div className="row">
                  <div className="col-md-3"></div>

                  <div className="col-md-6">
                    <div className="Steps">
                      <p>
                        Find and create fully customized day by day itinerary of
                        Places to Stay and Things to Do during your Seychelles
                        Travels. You can add your interest by choosing from our
                        defined itinerary or create your own.
                      </p>
                      <div
                        className="table_item"
                        style={{ margin: "auto", width: "50%" }}
                      >
                        <div
                          style={{
                            padding: "15px 20px 15px 20px",
                            marginTop: "10px",
                          }}
                        >
                          <button className="payLaterConfirmBooking"  onClick={StartPlanning}>
                            Start Planning
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3"></div>
                </div>
              </div>
            </section> */}
          </div>
        </div>
      </div>
    </div>
  );
}
